module.exports = __webpack_public_path__ + "img/y-240.32629d17.png";